module.exports = __webpack_public_path__ + "static/media/Cross-Left.d1e6c617.png";